import { IElektroSamsvarserklaringEkomnettRapport } from "../reportSchemas/elektroSamsvarserklaringEkomnettSchema";

export const ELEKTRO_SAMSVARSERKLARING_EKOMNETT_INIT_DATA: IElektroSamsvarserklaringEkomnettRapport = {
  generellInfo: {
    utarbeidetAv: "",
    kontrollertAv: "",
    godkjentAv: "",
    dokumentNr: "",
    revisjonsNr: "",
  },
  oppdragsgiver: {
    navn: "",
    oppdragsnummer: "",
    kontaktperson: "",
    adresse: "",
    postboks: "",
    postNr: "",
    sted: "",
    telefon: "",
    email: "",
    kundenummer: "",
  },
  anleggsadresse: {
    navn: "",
    adresse: "",
    postNr: "",
    sted: "",
    husNr: "",
    husNrBokstav: "",
    boligMappeId: "",
  },
  kontaktperson: {
    eierBrukerAnnet: null,
    navn: "",
    telefon: "",
    email: "",
  },
  ordreopplysninger: {
    ordreNummer: "",
    startDato: "",
    avsluttetDato: "",
  },
  utarbeidetAv: {
    navn: "",
    kontaktPerson: "",
    adresse: "",
    postNr: "",
    sted: "",
    telefon: "",
    email: "",
    organisasjonsNr: "",
    enaAutorisasjonsNr: "",
  },
  fravikFraAnvendteNormer: "",
  anleggsbeskrivelse: {
    typeAnlegg: null,
    utfoertIht: [],
    arbeidsbeskrivelse: "",
  },
  generatedAt: "",
  generatedBy: "",
};
